export const OldPortfolioOptions = [
  {
    infoTextKey: 'app.oldPortfolioState.transferCapitalLoss.info',
    label: 'app.oldPortfolioState.transferCapitalLoss',
    name: 'app.oldPortfolioState.transferCapitalLoss',
    model: 'transferCapitalLoss',
  },
  {
    infoTextKey: 'app.oldPortfolioState.disposeSavingsPlan.info',
    label: 'app.oldPortfolioState.disposeSavingsPlan',
    name: 'app.oldPortfolioState.disposeSavingsPlan',
    model: 'disposeSavingsPlan',
  },
];

export const OldPortfolioMessages = {
  fragmentsProceedsDestinationIban: {
    iban: 'app.oldPortfolioState.error.fragmentsProceedsDestinationIban.invalid',
    required: 'app.oldPortfolioState.error.fragmentsProceedsDestinationIban',
  },
  oldAccountNumber: {
    required: 'app.oldPortfolioState.error.oldAccountNumber',
    oldAccountNumberEqualsNewAccountNumber:
      'app.oldPortfolioState.error.oldAccountNumberEqualsNewAccountNumber',
  },
  oldBankIdentifier: {
    required: 'app.oldPortfolioState.error.oldBankIdentifier',
    invalidBankIdentifier: 'app.oldPortfolioState.error.invalidBankIdentifier',
  },
  fragmentsProceedsDestinationBic: {
    bic: 'app.oldPortfolioState.fragmentsProceedsDestinationBic.invalid',
    required: 'app.oldPortfolioState.error.fragmentsProceedsDestinationBic',
  },
  fragmentsProceedsDestinationBankName: {
    required:
      'app.oldPortfolioState.error.fragmentsProceedsDestinationBankName',
  },
  fragmentsProceedsDestinationAccountOwner: {
    required:
      'app.oldPortfolioState.error.fragmentsProceedsDestinationAccountOwner',
  },
};



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/oldPortfolio.constant.js